import { loadLocaleNamespace, loadMultipleNamespaces } from "./loader";

const baseLocaleFiles = ["layout", "app", "common", "pay"];
// 预加载常用语言包
export function preloadCommonLocales(immediate = true) {
  if (immediate) {
    loadMultipleNamespaces(systemStorage.value.lang || "en", baseLocaleFiles);
    return;
  }
  if (!("requestIdleCallback" in window)) return;

  const lang = systemStorage.value.lang || "en";

  requestIdleCallback(() => {
    // 预加载通用语言包
    loadMultipleNamespaces(lang, baseLocaleFiles);
  });
}
